import { IRenewalsFiltersModel } from '../../../models/interfaces/RenewalFilters/RenewalsFiltersModel';

export const initFilter: IRenewalsFiltersModel = {
  expirationDateFilters: [],
  productFilters: [],
  renewalStatusFilters: [],
  gGPocRolePersonFilters: [],
};
